var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"s-breadcrumb-item",class:{'s-to-path':_vm.to!=''},on:{"click":function($event){return _vm.clickItem()}}},[_vm._t("default"),(_vm.to!='')?_c('s-icon',{attrs:{"icon":_vm.icon}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }